// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getNewsArticleContent } from '../../../store/routes';
import Wysiwyg from '../../wysiwyg';
import Wrapper from '../atoms';
import { Container } from '../../grid';

type StateProps = {|
  content: string,
|};

const NewsArticleContent = ({ content }: StateProps) => (
  <Container>
    <Wrapper>
      <Wysiwyg
        content={content}
        template="default"
        variant="primary_primary"
        position="top"
      />
    </Wrapper>
  </Container>
);

const mapStateToProps = (state): StateProps => ({
  content: getNewsArticleContent(state),
});

export default connect<any, void, StateProps, any, any, any>(mapStateToProps)(NewsArticleContent);
